
const Widgets_actions = {

}

export default Widgets_actions;
